import React from 'react';
import Dialog from 'libraries/Dialog';
import { format } from 'date-fns';
import GradeBlock from '../../GradeBlock';
import CardScoreBlock from '../../CardScoreBlock';
import NotCompletedBlock from '../../NotCompletedBlock';

const ReapplyCardDialog = (props) => {
    const { onClose, open, historyItem, classes, fullName } = props;

    const handleClose = () => {
        onClose();
    };

    if (!historyItem) return null;
    const { auditionName, score, gradedBy, userAuditionId, completedAt, scoreType, completed, hasScreeningQuestions } = historyItem;

    return (
        <Dialog
            maxWidth="md"
            onClose={handleClose}
            handleClose={handleClose}

            titleComponent={auditionName}
            open={open}
        >
            <div className={classes.wrapper}>
                <div className={classes.topDateLabel}>
                    {completed ? format(new Date(completedAt), 'd MMMM, yyyy') : <span>Incomplete</span>}
                </div>
                {
                    completed ? (
                        <CardScoreBlock
                            propPublic={false}
                            showPerformance
                            showPercentage
                            showOverallRank={false}
                            candidate={{
                                score,
                                gradedBy,
                                scoreType,
                                completed
                            }}
                        />
                    ) : (
                        <div style={{ minHeight: 250 }}>
                            <NotCompletedBlock audition="show" />
                        </div>
                    )
                }

                {
                    (completed || hasScreeningQuestions) && (
                        <GradeBlock
                            readOnly
                            candidate={{
                                userAuditionId,
                                fullName
                            }}
                            propPublic={false}
                            isIntegration={false}
                        />
                    )
                }
            </div>
        </Dialog>
    );
};

export default ReapplyCardDialog;
